<template>
  <DialogTemplate
    class="board-filter"
    contentStyle="padding:0;margin:0; overflow: hidden;"
    actionsClass="bt-grey_2"
  >
    <!-- :hasBigTitle="newdrill" -->
    <!-- :editableName="customPreset" -->
    <!-- <div class="d-flex" style="min-sheight: 0"> -->
    <TrainerAdvancedFilter
      ref="form"
      style="--glo-hs-back: var(--clr-black-1)"
      :namespace="namespace"
      :tmpNamespace="tmpNamespace"
      :defaultTab="defaultTab"
      @start:drill="confirm"
    />
    <!-- :inDialog="true" -->
    <!-- <TrainerPresets :namespace="tmpNamespace" @start="$emit('start:drill')" /> -->
    <!-- </div> -->

    <template #dialog_actions>
      <v-btn
        v-if="!newdrill && !editdrill"
        class="mt-auto"
        data-tst="btn_open_dialog_save_drill"
        @click="savePreset"
      >
        <i class="mdi mdi-content-save text-semi-large mr-1"></i>
        {{ $t('btn.save') }}
      </v-btn>
      <v-btn
        id="trainer-settings-btn-close"
        variant="text"
        class="ml-auto mr-2"
        data-tst="btn_close"
        @click="close"
      >
        {{ $t('btn.close') }}
      </v-btn>
      <v-btn
        v-if="newdrill || editdrill"
        color="primary"
        :loading="loading"
        data-tst="btn_drill_table_open_dialog_save_drill"
        @click="confirm"
      >
        <i class="mdi mdi-content-save text-normal mr-1"></i>
        {{ $t('btn.save') }}
      </v-btn>
      <v-btn
        v-else
        color="primary"
        data-tst="btn_start_training"
        @click="confirm"
      >
        <i class="text-semi-large mr-1 mdi mdi-play"></i>
        {{ $t('btn.start_training') }}
      </v-btn>
    </template>
  </DialogTemplate>
</template>

<script>
import DialogTemplate from '@/components/Dialogs/DialogTemplate'
import TrainerAdvancedFilter from '@/components/Trainer/TrainerAdvancedFilter'
import { getTrainerClearQuery } from '@/helpers/trainer_presets'
import { da } from 'date-fns/locale'

export default {
  name: 'TrainerAdvancedFilterDialog',
  components: {
    TrainerAdvancedFilter,
    DialogTemplate,
  },
  props: {
    dialog: Object,
  },
  emits: ['start:drill'],
  data() {
    return {}
  },
  methods: {
    openPresetSaveDialog() {
      const dialog = `save-drill-dialog_namespace-${this.namespace}_tmpNamespace-${this.tmpNamespace}`
      this.$store.dispatch('router_set_dialogs', dialog)
    },
    savePreset() {
      if (this.editdrill) {
        const l_preset = { ...this.$store.getters.drills_selected_drill }
        const router_query = this.$store.getters[`${this.namespace}/router_query`]
        const completePreset = {
          ...l_preset,
          query: getTrainerClearQuery(router_query),
        }
        if (JSON.stringify(completePreset) === JSON.stringify(l_preset)) {
          this.close()
          return
        }
        this.$store.dispatch('drills_set_drill', {
          items: [completePreset],
          hasMessage: true,
          method: 'PATCH',
          namespace: this.namespace,
        })
        return
      }
      this.openPresetSaveDialog()
    },
    close() {
      this.$store.dispatch('router_rm_dialog', 'trainer-advanced-filter-dialog')
    },
    apply() {
      this.confirm()
    },
    confirm() {
      if ((this.newdrill || this.editdrill) && this.$route.name !== 'practiceTrainer') {
        this.savePreset()
        return
      }
      this.$refs.form.apply()
      this.$store.dispatch(`hands_start_session`)
      this.close()
    },
  },
  computed: {
    namespace() {
      return this.dialog.namespace || ''
    },
    tmpNamespace() {
      return this.dialog.tmpNamespace || ''
    },
    defaultTab() {
      return this.dialog.tab || ''
    },
    editdrill() {
      return this.dialog.editdrill
    },
    newdrill() {
      return this.dialog.newdrill
    },
    loading() {
      return this.$store.getters.api_get('api_poker_drill').loading
    },
  },
}
</script>
